import axios from "axios";
import { getApiRoute } from "src/services";
import { useMutation } from "@tanstack/react-query";

async function removeFromGroup({ groupId, calendarId }) {
  await axios.post(
    getApiRoute("user", "REMOVE_CALENDAR_FROM_GROUP"),
    { groupId, calendarId },
    { withCredentials: true }
  );
}

export function useRemoveFromGroup() {
  return useMutation(removeFromGroup);
}